import {
  axiosGet,
  axiosPatch,
  axiosPost,
  axiosPut,
} from "../axois_V2/axoisWithAuthV2";
import { INGOForm } from "../pages/AddEditNGOPage/const";
import { BasePayload, UserRole } from "../types";
import { throwError } from "../utils/error";

export const ngoBaseURL_V2 = "/ngo/v2";

interface OrgNGOPayload extends BasePayload {
  search?: string;
  organizationId?: string;
}

interface UpdateAdminNGOPayload extends Partial<INGOForm> { }
export interface AddNGOPayload extends INGOForm { }

export const getNGOByOrganization_V2 = async (payload: OrgNGOPayload) => {
  try {
    const res = await axiosGet(
      `${ngoBaseURL_V2}/organization/${payload.organizationId}?page=${payload.page || ""}&limit=${payload.limit || ""}&search=${payload.search || ""}`
    );
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getAllNGO_V2 = async (payload: OrgNGOPayload) => {
  try {
    const res = await axiosGet(`${ngoBaseURL_V2}/all?page=${payload.page || ""}&limit=${payload.limit || ""}&search=${payload.search || ""}`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const createNGO_V2 = async (payload: FormData) => {
  try {
    const res = await axiosPost(`${ngoBaseURL_V2}/create-ngo`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getNGOById_V2 = async (ngoId: string, role?: UserRole) => {
  try {
    const res = await axiosGet(`${ngoBaseURL_V2}/${ngoId}`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const updateAdminNGO_V2 = async (
  ngoId: string,
  payload: UpdateAdminNGOPayload
) => {
  try {
    const res = await axiosPatch(
      `${ngoBaseURL_V2}/update-ngo/${ngoId}`,
      payload
    );
    return res.data;
  } catch (error) {
    throwError(error);
  }
};

export const uploadNgoImage_V2 = async (ngoId: string, payload: FormData) => {
  try {
    const res = await axiosPut(
      `${ngoBaseURL_V2}/update-image/${ngoId}`,
      payload
    );
    return res;
  } catch (error) {
    throwError(error);
  }
};

// export const deleteNGO = async (ngoId: string) => {
//     try {
//         const res = await axiosDelete(`/ngo/${ngoId}`);
//         return res.data
//     } catch (error) {
//         throwError(error);
//     }
// }

export const getNgoCities_V2 = async (ngoId: string) => {
  try {
    const res = await axiosGet(`${ngoBaseURL_V2}/${ngoId}/cities`);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const linkNGOsToOrganization = async (payload: { ngos: string[] }) => {
  try {
    const res = await axiosPost(`${ngoBaseURL_V2}/link-ngo`, payload);
    return res;
  } catch (error) {
    throwError(error);
  }
};

export const getNgosByCampaign_V2 = async (campaignId: string) => {
  try {
    const response = await axiosGet(`${ngoBaseURL_V2}/${campaignId}/ngos`);
    return response;

  } catch (error) {
    throwError(error);
  }
}
